module.exports = __webpack_public_path__ + "static/media/inactive-policy-background.0c6c1648.svg";